/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ISalesConfigTaxesResponse } from '../models/ISalesConfigTaxesResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SalesConfigTaxesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ISalesConfigTaxesResponse
     * @throws ApiError
     */
    public getSalesConfigTaxesIndex(): CancelablePromise<ISalesConfigTaxesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sales/config/taxes',
        });
    }

}
